<template>
  <div style="width: 100%">
    <div class="common-table">
      <div class="table-head">
        <span class="head-title margin-bottom-15">1.公对公转账信息</span>
        <span class="tips">请核对公对公转账信息后完成银行转账汇款。</span>
      </div>
      <div v-for="item in accountList" :key="item.key" class="table-row">
        <span>{{ item.name }}</span>
        <span
          >{{ getWLOptions ? getWLOptions[item.key] : "" }}
          <el-button
            v-if="item.key === 'receiveBankAccount'"
            class="copy-btn"
            @click="copyText(getWLOptions[item.key])"
            >复制</el-button
          ></span
        >
        <!-- <span>{{ item.info }}</span> -->
      </div>
    </div>
    <div class="common-table">
      <div class="table-head">
        <span class="tips1"
          >转账时用途备注“订单号+物流专区服务费”。转账完成后，请您上传凭证提供订单号及银行盖章回执单，以便更快完成对公汇款确认。</span
        >
      </div>
    </div>
    <div class="common-table">
      <div class="table-head">
        <span class="head-title">2. 汇款信息</span>
      </div>
      <el-form
        ref="form"
        class="table-form"
        label-width="300px"
        :model="formData"
        :rules="rules"
      >
        <el-form-item
          label="汇款银行账户名称："
          prop="remittanceBankAccountName"
        >
          <el-input
            class="input-width"
            v-model="formData.remittanceBankAccountName"
            placeholder="请输入汇款银行账户名称："
          ></el-input>
        </el-form-item>
        <el-form-item label="汇款银行账户账号：" prop="remittanceBankAccountNo">
          <el-input
            class="input-width"
            v-model="formData.remittanceBankAccountNo"
            placeholder="请输入汇款银行账户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="汇款开户行：" prop="remittanceOpenBankName">
          <el-input
            class="input-width"
            v-model="formData.remittanceOpenBankName"
            placeholder="请输入汇款开户行"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="汇款开户行全称："
          prop="remittanceOpenBankFullName"
        >
          <el-input
            class="input-width"
            v-model="formData.remittanceOpenBankFullName"
            placeholder="请输入汇款开户行全称"
          ></el-input>
        </el-form-item>
        <el-form-item label="转账附言/用途：" prop="remittanceTransferNotes">
          <el-input
            class="input-width"
            v-model="formData.remittanceTransferNotes"
            placeholder="请输入转账附言/用途"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="支付凭证附件(银行盖章回执单)："
          v-model="formData.uploadId"
          prop="uploadId"
        >
          <el-input v-model="formData.uploadId" v-show="false"></el-input>
          <fileUpload
            :accept="['.jpg', '.png', '.pdf']"
            @success="uploadSuccess"
            :limit="1"
            ref="fileUploadRef"
          ></fileUpload>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group"></div>
  </div>
</template>

<script>
const ACCOUNTS_MAP = [
  {
    name: "收款银行账户名称",
    key: "receiveBankName",
    info: "必填",
  },
  {
    name: "收款银行账户账号",
    key: "receiveBankAccount",
    info: "必填",
  },
  {
    name: "开户行",
    key: "openBankName",
    info: "必填",
  },
  {
    name: "开户行全称",
    key: "openBankFullName",
    info: "必填",
  },
  {
    name: "转账附言/用途",
    key: "transferNotes",
    info: "必填，转账请备注此信息",
  },
  {
    name: "财务地址及信息",
    key: "financialAddressInfo",
    info: "",
  },
];
import fileUpload from "./components/fileUpload.vue";
export default {
  name: "publicToPublic",
  components: {
    fileUpload,
  },
  props: {
    orderCode: {
      type: String,
      default: "",
    },
  },
  inject: ["getWLOptions", "gongduigongInfo"],
  data() {
    return {
      accountList: Object.freeze(ACCOUNTS_MAP),
      formData: {
        remittanceBankAccountName: "",
        remittanceBankAccountNo: "",
        remittanceOpenBankName: "",
        remittanceOpenBankFullName: "",
        credentialsUploadTime: "",
        remittanceTransferNotes: "",
        uploadId: "",
        fileName: "",
        fileUrl: "",
        fileSize: "",
        updateTime: "",
      },
      rules: {
        remittanceBankAccountName: [
          {
            required: true,
            message: "请输入汇款银行账户名称：",
            trigger: "blur",
          },
        ],
        remittanceBankAccountNo: [
          {
            required: true,
            message: "请输入汇款银行账户账号",
            trigger: "blur",
          },
        ],
        remittanceOpenBankName: [
          { required: true, message: "请输入汇款开户行", trigger: "blur" },
        ],
        remittanceOpenBankFullName: [
          { required: true, message: "请输入汇款开户行全称", trigger: "blur" },
        ],
        remittanceTransferNotes: [
          { required: true, message: "请输入转账附言/用途", trigger: "blur" },
        ],
        uploadId: [{ required: true, message: "请上传凭证" }],
      },
    };
  },
  mounted() {
    this.formData.remittanceTransferNotes = this.orderCode + " 物流专区服务费";
  },
  methods: {
    setData() {
      let val = sessionStorage.getItem("gongduigongInfo");
      if (val) {
        const da = JSON.parse(val);
        console.log(da, "设置公对公信息");
        for (let key in da) {
          if (this.formData.hasOwnProperty(key)) {
            this.formData[key] = da[key];
          }
        }
        this.$refs.fileUploadRef.setFileList([
          {
            uploadId: da.uploadId,
            fileUrl: da.fileUrl,
            fileName: da.fileName,
            downloadUrl: da.fileUrl,
            fileGxId: da.fileGxId,
          },
        ]);
      }
    },
    uploadSuccess(fileList) {
      const file = fileList[0];
      if (file) {
        const { uploadId, fileName, downloadUrl, fileSize, updateTime } = file;
        this.formData.uploadId = uploadId;
        this.formData.fileName = fileName;
        this.formData.fileUrl = downloadUrl;
        this.formData.fileSize = fileSize;
        this.formData.updateTime = updateTime;
        this.formData.credentialsUploadTime = updateTime;
      } else {
        this.formData.uploadId = "";
        this.formData.fileName = "";
        this.formData.fileUrl = "";
        this.formData.fileSize = "";
        this.formData.updateTime = "";
        this.formData.credentialsUploadTime = "";
      }
    },
    // 表单校验
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve(this.formData);
          } else {
            resolve(false);
          }
        });
      });
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功！");
    },
  },
};
</script>

<style lang="scss" scoped>
.common-table {
  border: 1px solid #f1f1f1;
  margin: 20px;
  width: calc(100% - 40px);
  min-width: 60px;
  border-radius: 8px;
  .table-head {
    padding: 20px;
    background: #f9fafb;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    flex-direction: column;
  }
  .table-row {
    display: flex;
    justify-content: space-between;
    padding: 0 30% 0 20px;
    height: 49;
    line-height: 49px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #f1f1f1;
    span {
      flex: 1;
    }
  }
  .table-form {
    margin: 40px 0;
  }
}

.margin-bottom-15 {
  margin-bottom: 15px;
}
.tips {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ff142f;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.tips1 {
  font-family: PingFangSC, PingFang SC;
  font-size: 13px;
  color: #4a4a4a;
}
.input-width {
  width: 500px;
}
.copy-btn {
  padding: 0 7px;
  height: 25px;
  border-color: red;
  color: red;
}
</style>
